import { Dialog, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../Assets/svgs/close-icon-info.svg";
import Loader from "../Common/Loader";
import { BASE_URL_MAIN } from "../../config/ApiConfig";
import { GetMagnifiedImage } from "../../services/ImageInformation";

const MagnifyImageModal = ({
  open,
  onClose,
  selectedMagnifyImage,
  zoomImage,
}) => {
  const [isLoadingNewImage, setIsLoadingNewImage] = useState(false);
  const [newImageData, setNewImageData] = useState();
  // const getImageUrl = async () => {
  //   setIsLoadingNewImage(true);
  //   const payload = {
  //     image_name: selectedMagnifyImage?.imageName,
  //     shootid: selectedMagnifyImage?.imageShootId,
  //   };
  //   const response = await GetMagnifiedImage(payload);
  //   setNewImageData(response);
  //   setIsLoadingNewImage(false);
  // };
  // useEffect(() => {
  //   getImageUrl();
  // }, []);
  // useEffect(() => {
  //   const hideLoaderAfterDelay = () => {
  //     if (isLoadingNewImage === true) {
  //       setIsLoadingNewImage(false);
  //       onClose();
  //     }
  //   };
  //   const timeoutId = setTimeout(hideLoaderAfterDelay, 10000);
  //   return () => clearTimeout(timeoutId);
  // }, [isLoadingNewImage]);
  // useEffect(() => {
  //   const hideLoaderAfterDelay = () => {
  //     if (isLoadingNewImage === true) {
  //       setIsLoadingNewImage(false);
  //       onClose();
  //     }
  //   };
  //   const timeoutId = setTimeout(hideLoaderAfterDelay, 10000);
  //   return () => clearTimeout(timeoutId);
  // }, [isLoadingNewImage]);

  return (
    <>
      <Dialog
        className="transparent-dialog"
        fullWidth={true}
        open={open}
        maxWidth={"lg"}
        componentsProps={{
          backdrop: { style: { backgroundColor: "rgba(0,0,0,0.8)" } },
        }}
        PaperComponent={"div"}
        PaperProps={{
          sx: {
            boxShadow: "none",
            margin: 0,
            width: "fit-content",
          },
        }}
        onClose={onClose}
      >
        <div
          style={{ position: "fixed", zIndex: 1, right: "10px", top: "10px" }}
        >
          <IconButton className="zoomImageButton" onClick={onClose}>
            <CloseIcon className="image-menu-vertical-icon image-menu-icon" />
          </IconButton>
        </div>
        {isLoadingNewImage === true && <Loader />}
        {/* <img
          src={selectedMagnifyImage?.imageUrl}
          style={{
            maxWidth: "fit-content",
            maxHeight: "80vh",
            // objectFit: "contain",
            transition: "0.7s",
            display: isLoadingNewImage ? "block" : "none",
            // margin: "auto",
            filter: "blur(6px)",
            height: "100%",
          }}
          alt="Magnify Image"
        />
        <img
          src={`${BASE_URL_MAIN}common/imageResize/${selectedMagnifyImage?.imageName}?shootid=${selectedMagnifyImage?.imageShootId}`}
          style={{
            maxWidth: "fit-content",
            maxHeight: "80vh",
            // objectFit: "contain",
            transition: "0.7s",
            display: isLoadingNewImage ? "none" : "block",
            // margin: "auto",
            height: "100%",
          }}
          onLoad={() => setIsLoadingNewImage(false)}
          alt="Magnify Image"
        /> */}
        <img
          // src={newImageData ? newImageData : selectedMagnifyImage?.imageUrl}
          src={zoomImage}
          style={{
            maxWidth: "fit-content",
            maxHeight: "80vh",
            // objectFit: "contain",
            transition: "0.7s",
            display: "block",
            // margin: "auto",
            // filter: newImageData ? "" : "blur(6px)",
            height: "100%",
          }}
          alt="Magnify Image"
        />
      </Dialog>
    </>
  );
};

export default MagnifyImageModal;
